<template>
    <div id="lineGraphic">
        <div class="sub-header">
            <div class="left">
                <md-icon>help</md-icon>
                <div class="title">
                    {{ $t(`chatbotv2.${subTitle}`) }}
                </div>
            </div>
            <div class="right">
                <div class="export-button" @click="exportToCsv">
                    <md-icon>system_update_alt</md-icon>
                    <span>{{ $t("chatbotv2.exportToCsv") }}</span>
                </div>
                <div class="export-button" @click="exportToExcel">
                    <md-icon>system_update_alt</md-icon>
                    <span>{{ $t("chatbotv2.exportToExcel") }}</span>
                </div>
            </div>
        </div>
        <div class="data-info">
            <div class="total">
                <p>{{ totalData.message }}</p>
                <p class="data-value">{{ totalData.value }}</p>
            </div>
            <div class="avg">
                <p>{{ avgData.message }}</p>
                <p class="data-value">{{ avgData.value }}</p>
            </div>
        </div>
        <div class="line-graphic-container">
            <div id="xAxisTickTimeseries" class="chart"></div>
        </div>
    </div>
</template>

<script>
import * as d3 from "d3";
import { bb, area, zoom } from "billboard.js";
import "billboard.js/dist/billboard.css";
import "billboard.js/dist/theme/insight.css";
import { expertToExcel, exportToCSV } from "../../../../utils/utils";
import XLSX from "xlsx";

export default {
    name: "LineGraphic",
    props: ["graphData", "totalData", "avgData", "subTitle", "timeSeriesType"],
    data() {
        return {};
    },
    methods: {
        generateChart() {
            var chart = bb.generate({
                data: {
                    x: "x",
                    json: {
                        AllChats: this.graphData.map((item) => item.value),
                        x: this.graphData.map((item) => item.date),
                    },
                    type: "area", // for ESM specify as: area()
                    xFormat: "%m-%d-%Y %H:%M",
                },
                axis: {
                    x: {
                        tick:
                            this.timeSeriesType === "hourly"
                                ? {
                                      format: "%H:%M",
                                      values: this.graphData
                                          .map((item) => item.date)
                                          .concat()
                                          .splice(1)
                                          .map(function (v) {
                                              return v.replace(/(:\d{2}){2}$/, ":00:00");
                                          }),
                                  }
                                : {
                                      format: "%Y-%m-%d",
                                  },
                        type: "timeseries",
                    },
                },
                grid: {
                    y: {
                        lines: this.graphData.map((item) => ({
                            value: item.value,
                            class: "y-line",
                        })),
                    },
                },
                zoom: {
                    enabled: true, // for ESM specify as: zoom()
                    type: "drag",
                },
                tooltip: {
                    format:
                        this.timeSeriesType === "hourly"
                            ? {
                                  title: function (x) {
                                      return d3.timeFormat("%Y-%m-%d %H:%M")(x);
                                  },
                              }
                            : {
                                  title: function (x) {
                                      return d3.timeFormat("%m-%d-%Y")(x);
                                  },
                              },
                },
                point: {
                    show: true,
                },
                bindto: "#xAxisTickTimeseries",
            });
            chart.data.colors({ AllChats: "#018AFF" });
        },
        exportToCsv() {
            const data = this.graphData.map((item) => ({
                date: item.date,
                value: item.value,
            }));
            exportToCSV(data, `chatbot_all_chat.csv`);
        },
        exportToExcel() {
            const data = this.graphData.map((item) => ({
                date: item.date,
                value: item.value,
            }));
            expertToExcel(data, "chatbot_all_chat.xlsx", "Chat Data");
        },
    },
    mounted() {
        if (!!this.graphData) this.generateChart();
    },
};
</script>

<style lang="scss" scoped>
.sub-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 0px 20px;

    .left {
        display: flex;
        justify-content: space-between;
        align-items: center;

        i {
            font-size: 18px !important;
        }

        .title {
            font-size: 19px;
        }
    }

    .right {
        min-width: 80px;
        display: flex;
        gap: 10px;
        padding: 5px 10px;
        user-select: none;

        .export-button {
            border: 1px solid #008aff;
            padding: 5px;
            cursor: pointer;
            color: #008aff;
            border-radius: 4px;

            &:hover {
                background: var(--color-bg-hover);
            }

            i {
                color: #008aff;
                font-size: 17px !important;
            }
        }
    }
}

.data-info {
    width: 20%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    margin-bottom: 20px;
    margin-top: 20px;

    .total {
        margin-right: 20px;
        font-weight: 600;
        line-height: 23px;

        p {
            margin: 0;
            padding: 0;
        }

        .data-value {
            font-size: 28px;
            line-height: 36px;
        }
    }

    .avg {
        font-weight: 600;
        line-height: 23px;

        p {
            margin: 0;
            padding: 0;
        }

        .data-value {
            font-size: 28px;
            line-height: 36px;
        }
    }
}

.y-line {
    line {
        stroke: black;
        opacity: 0.1;
    }
}
</style>
